import React, {FC, useEffect} from 'react'
import {Hint, Spinner, Stack} from '@mdsol/onex-design'
import {useSelector} from 'react-redux'
import {useAppDispatch} from 'redux/config'
import {
  select_currentLegionFeatureFlags,
  select_databaseIdToCopy,
} from 'redux/databases/selectors'
import {fetchFeatureFlags} from 'redux/databases/databases.duck'
import {Status} from 'commonTypes'
import {Card} from '@mdsol/onex-design'
import {FeatureFlag} from './FeatureFlag'
import {select_auth_user} from 'redux/auth/selectors'

const FeatureFlagsControls: FC = () => {
  const dispatch = useAppDispatch()
  const databaseId = useSelector(select_databaseIdToCopy)
  const {status, flags} = useSelector(select_currentLegionFeatureFlags)
  const flagsKeys = Object.keys(flags)
  const {isAdmin} = useSelector(select_auth_user)

  useEffect(() => {
    dispatch(fetchFeatureFlags(databaseId))
  }, [dispatch, databaseId])

  return (
    <Stack className='feature-flags'>
      <Card
        showTitleBar
        expandableBody={
          <Stack className='feature-flags scrollable'>
            {status === Status.OK || status === Status.IDLE
              ? <>
                {
                  flagsKeys.map(flag => {
                    if (flag) {
                      return <FeatureFlag
                        key={flag}
                        databaseId={databaseId}
                        name={flag}
                        status={flags[flag]}
                        disabled={!isAdmin}
                      />
                    }
                  })
                }
              </>
              : <Stack direction='horizontal' className='switch-wrapper'>
                {status === Status.PENDING ?
                  <Spinner dataTestId='job-details-spinner' size='sm'/>
                  :
                  <Hint
                    dataTestId='hint-info'
                    variant='critical'
                  >
                    Unable to load feature flags at this time.
                  </Hint>
                }
              </Stack>
            }
          </Stack>
        }
        isExpanded={true}
        id='onex-components-card--info'
        variant='information'
        role='legion-feature-flags-card'
        title='Feature Flags'
      >
        <div className='hidden-card-body'></div>
      </Card>
    </Stack>
  )
}

export default FeatureFlagsControls
